<template>
  <div :class="$style.recall">
    <Login
      v-if="loginVisible"
      @close="closeLogin"
      @forget="showReset"
      ref="login"
      @freshTemp="freshTemp"
    ></Login>
    <ResetPwd
      v-if="resetVisible"
      @back="showLogin"
      @close="resetVisible = false"
    ></ResetPwd>
    <Activity @login="login" ref="activity"></Activity>
  </div>
</template>

<script>
import Login from "@/components/recall/Login.vue";
import ResetPwd from "@/components/recall/ResetPwd.vue";
import Activity from "@/components/recall/Activity";
import { loginByCode, temlateStatus } from "@/apis/recall";
import { mapActions, mapMutations } from "vuex";
import { setRem } from "@/libs/rem";

export default {
  name: "",
  data() {
    return {
      loginVisible: false,
      resetVisible: false,
      tempId: 0,
    };
  },
  mounted() {
    document.title = "召回活动";
    this.setTemplateId();
    this.checkLoginState();
    this.insert53Code();
    setTimeout(() => {
      setRem();
    }, 200);
  },
  methods: {
    ...mapMutations({
      setRecallState: "recall/CHANGE_RECALL_STATE",
    }),
    ...mapActions({
      getUserInfo: "recall/getUserInfo",
      getUserMBList: "recall/getUserMBList",
      getBoundList: "recall/getBoundList",
      getLoginMBList: "recall/getLoginMBList",
    }),
    // 登录后刷新活动模板
    freshTemp() {
      this.$refs.activity.getCommonActivities();
    },
    showReset() {
      this.loginVisible = false;
      this.resetVisible = true;
    },
    showLogin(phone) {
      this.loginVisible = true;
      this.resetVisible = false;
    },
    // 缓存当前模板id
    async setTemplateId() {
      const oldId = localStorage.getItem("tempId");

      const type = this.$route.params.type ? this.$route.params.type : 0;
      if (type === 0) {
        localStorage.removeItem("tempId");
        this.$router.push({ name: "recall-404", query: { type: 1 } });
        return;
      }
      const id = atob(decodeURIComponent(type)).split("-")[1];

      if (oldId && oldId !== id) {
        localStorage.removeItem("token");
      }
      this.tempId = id;
      localStorage.setItem("tempId", id);
      this.setRecallState({ template_id: id });

      const r = await temlateStatus({});
      if (r.content === 2) {
        this.$router.push({ name: "recall-404", query: { type: 1 } });
        return;
      }
      if (r.content === 3) {
        this.$router.push({ name: "recall-404", query: { type: 2 } });
        return;
      }
    },
    async checkLoginState() {
      const token = localStorage.getItem("token") || "";
      const { code } = this.$route.query;

      if (code) {
        try {
          await this.loginByCode(code);
        } catch (error) {
          if (token) {
            this.setRecallState({ token });
            this.getUserInfo();
          }
        }
      } else if (token) {
        this.setRecallState({ token });
        this.getUserInfo();
      } else {
        this.getUserMBList();
      }
      // 登陆后刷新模板数据
      this.freshTemp();
    },
    async loginByCode(code) {
      const r = await loginByCode({ code: code, template_id: this.tempId });
      localStorage.setItem("token", r.content.token);
      if (r.ret !== 1) return;
      const obj = {
        token: r.content.token,
        summon_word: r.content.recall_code, // 召回码
        coin: r.content.credit, // 喵币余额
        total_coin: r.content.total_credit, // 总喵币余额
        is_return: r.content.is_return || 0, // 被召回者是否回归
        user_name: r.content.user_name, // 用户名
        last_lottery_times: r.content.last_lottery_times, // 剩余抽奖次数
        user_type: r.content.user_type, // 2.召回者 1.被召回者，
      };
      await this.setRecallState({ ...obj, loginType: 2 });
      this.getBoundList();
      this.getLoginMBList();
    },
    login() {
      this.loginVisible = true;
    },
    closeLogin() {
      this.loginVisible = false;
      setTimeout(() => {
        this.$refs.activity.refreshScroll();
      }, 200);
    },
    async insert53Code() {
      let _53code = document.createElement("script");
      let src = "//tb.53kf.com/code/code/7218fcbe99ccc9c959f32b5afc7eb38e4/3";
      let id =
        Math.floor(Math.random() * (1000000000 - 100000000 + 1)) + 100000000;
      src = `${src}?u_cust_id=ZHHD${id}&u_cust_name=召回活动玩家`;
      _53code.src = src;
      _53code.async = "async";
      let s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(_53code, s);
    },
  },
  components: {
    Login,
    ResetPwd,
    Activity,
  },
};
</script>

<style lang="scss" module>
.recall {
  width: 100%;
  height: 100%;
}
</style>